export * from '../hooks/useValidateObjectForBillingConversion';
export * from '../hooks/usePortalCurrencies';
import { useHasValidPortalCurrency, usePortalCurrencies } from '../hooks/usePortalCurrencies';

// shims for backwards compatibility
/** @deprecated */
export const useHasValidCurrency = () => useHasValidPortalCurrency();

/** @deprecated */
export const useValidCurrencies = () => usePortalCurrencies().supportedCurrencies;